import Config from './users.router';
import options from './users.component';
import UACAddUser from './add-user';


const Component = {
    selector: 'dtUsersView',
    options
};

export {
    Config,
    Component,
    UACAddUser
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/users/index.js